/*=========================================================================================
  File Name: moduleFonDeCaisseState.js
  Description: FonDeCaisse Module State
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  fonddecaisses: []
}
